var _g, _g2, _g3, _g4, _g5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPlug(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "emoji",
    viewBox: "0 0 72 72",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "color"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#9b9b9a",
    stroke: "none",
    d: "M30.644,51.1065c0.5335-0.1424,1.0815,0.1746,1.224,0.708l1.455,5.449h8.387l1.455-5.426 c0.143-0.5334,0.6913-0.85,1.2248-0.7071c0.0001,0,0.0002,0,0.0002,0"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#3F3F3F",
    stroke: "none",
    d: "M33.013,24.1055c-0.5523,0-1-0.4477-1-1V8.2195c0-1.2744-1.0331-2.3075-2.3075-2.3075 c-1.2744,0-2.3075,1.0331-2.3075,2.3075v14.883c0,0.5523-0.4477,1-1,1"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#3F3F3F",
    stroke: "none",
    d: "M49.55,24.1055c-0.5523,0-1-0.4477-1-1V8.2195c-0.001-1.2741-1.0346-2.3062-2.3088-2.3052 c-1.2728,0.001-2.3043,1.0325-2.3052,2.3052v14.883c0,0.5523-0.4477,1-1,1"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#d0cfce",
    stroke: "none",
    d: "M47.601,24.1885H20.435v10.48c-0.0125,9.4811,7.6634,17.1771,17.1444,17.1895 c3.5425,0.0047,6.9998-1.0868,9.8976-3.1245C48.0699,40.5639,48.1113,32.3637,47.601,24.1885z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9b9b9a",
    stroke: "none",
    d: "M47.601,24.1885c0.5104,8.1755,0.469,16.3761-0.124,24.546c4.5953-3.2095,7.3349-8.4598,7.339-14.065 v-10.48L47.601,24.1885z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#d0cfce",
    stroke: "none",
    d: "M41.657,67.0965c-0.5523,0-1-0.4477-1-1v-7.083h-6.063v7.083c0,0.5523-0.4477,1-1,1"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "hair"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "skin"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "skin-shadow"
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "line"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000000",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2,
    d: "M33.013,23.0925V8.2105 c0-1.8264-1.4806-3.307-3.307-3.307h0l0,0c-1.8264,0-3.307,1.4806-3.307,3.307l0,0v14.883"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000000",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2,
    d: "M49.55,23.0925V8.2105 c0-1.8264-1.4806-3.307-3.307-3.307h0l0,0c-1.8264,0-3.307,1.4806-3.307,3.307l0,0v14.883"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M19.435,23.1885v11.48 c0,10.0461,8.1439,18.19,18.19,18.19s18.19-8.144,18.19-18.19v-11.48H19.435z"
  }), /*#__PURE__*/React.createElement("polyline", {
    fill: "none",
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    points: "31.011,51.8095 32.665,58.0005 42.586,58.0005 44.24,51.8335"
  }), /*#__PURE__*/React.createElement("polyline", {
    fill: "none",
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    points: "33.618,66.0835 33.618,58.0005 41.681,58.0005 41.681,66.0835"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlug);
export default __webpack_public_path__ + "static/media/plug.ca167f7d609b9b59603d0fa2fb40f87a.svg";
export { ForwardRef as ReactComponent };